<template>
    <v-card v-if="order">
        <v-container dense>
            <v-row dense>
                <v-col cols="12">
                    <v-row justify="space-between" no-gutters>
                        <v-col class="overline font-weight-bold grey--text" cols="auto">
                            <template v-if="car">
                                Автомобиль
                            </template>
                            <template v-else>
                                Пробег
                            </template>
                        </v-col>
                        <v-col class="overline font-weight-bold primary--text" cols="auto">
                            {{ dateFormatted }}
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col cols="auto">
                            <div class="text-center">
                                <template v-if="car">
                                    <div class="display-1">{{ car.model }}</div>
                                    <div class="display-1">{{ car.numberPlate }}</div>
                                    <div>Пробег: {{ order.mileage }} км</div>
                                </template>
                                <template v-else>
                                    <div class="display-1">{{ order.mileage }} км</div>
                                </template>
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12">
                    <v-divider/>
                </v-col>

                <v-col cols="12">
                    <div class="overline font-weight-bold grey--text">
                        Заказ-наряд
                    </div>
                    <div>
                        № {{ order.id }}
                    </div>
                </v-col>
                <v-col cols="12">
                    <div class="overline font-weight-bold grey--text">
                        СТО
                    </div>
                    <div>
                        {{ order.station }}
                    </div>
                </v-col>
                <v-col cols="12">
                    <div class="overline font-weight-bold grey--text">
                        Работа
                    </div>
                    <div v-if="order.works">
                        <v-row
                            v-for="work in order.works"
                            :key="`work_${work.id}`"
                            dense
                            justify="space-between"
                        >
                            <v-col cols="auto">
                                {{ work.name }}
                            </v-col>
                            <v-col cols="auto">
                                {{ work.sum | currency }}
                            </v-col>
                        </v-row>
                    </div>
                    <div v-else>
                        <span>-</span>
                    </div>
                </v-col>
                <v-col cols="12">
                    <div class="overline font-weight-bold grey--text">
                        Материал
                    </div>
                    <div v-if="order.items">
                        <v-row
                            v-for="item in order.items"
                            :key="`item_${item.id}`"
                            dense
                            justify="space-between"
                        >
                            <v-col cols="auto">
                                <span>{{ item.name }}</span>
                                <span class="ml-2 grey--text">x {{ item.quantity }}</span>
                            </v-col>
                            <v-col cols="auto">{{ item.sum | currency }}</v-col>
                        </v-row>
                    </div>
                    <div v-else>
                        <span>-</span>
                    </div>
                </v-col>
                <v-col cols="12">
                    <div class="overline font-weight-bold grey--text">
                        Общие рекомендации
                    </div>
                    <div v-if="order.recommendation">
                        {{ order.recommendation }}
                    </div>
                    <div v-else>
                        <span>-</span>
                    </div>
                </v-col>
                <v-col cols="12">
                    <v-divider/>
                </v-col>

                <v-col cols="12">
                    <v-row justify="space-between" no-gutters>
                        <v-col cols="auto">
                            Общая сумма
                        </v-col>
                        <v-col class="font-weight-bold" cols="auto">
                            {{ order.sum | currency }}
                        </v-col>
                    </v-row>
                </v-col>
                <template v-if="questions.length">
                    <v-col cols="12">
                        <v-divider/>
                    </v-col>

                    <v-col cols="12">
                        <v-btn
                            block
                            color="secondary"
                            :to="{ name: 'HistoryFeedback', params: { orderId: order.id } }"
                        >
                            Оставить оценку/отзыв
                        </v-btn>
                    </v-col>
                </template>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
    import moment from 'moment'
    import { mapGetters } from 'vuex'

    export default {
        name: 'OrderHistoryItem',

        props: {
            order: { type: Object },
            car: { type: Object },
        },

        computed: {
            ...mapGetters({
                getQuestionsByDate: 'feedback/getQuestionsByDate',
            }),

            dateFormatted() {
                const unix = this.order?.date

                if (unix) {
                    return moment.unix(unix).utcOffset(5).locale('ru').format('LLL')
                } else {
                    return null
                }
            },

            questions() {
                return this.getQuestionsByDate(this.order?.date)
            },
        },
    }
</script>
